module.exports = __webpack_public_path__ + "assets/img/finger.cd16eef9.png";